module.exports = __webpack_public_path__ + "img/public_dropdown_down_grey.8cb9d9bd.svg";